
define('eteration/widgets/ui-session-controls',[
    "jquery",
    "eteration/eteration-ajax",
    "eteration/eteration-i18n",
    "eteration/eteration-urlparser",
    "ui-helper/gtm-helper",
    "ui-helper/storage-helper"
], function ($, etrAjax, i18n, urlParser, gtmUtil, storageHelper) {
    var PAGE = {
        SCHEDULE: 1,
        AVAILABILITY: 2,
        SUMMARY: 3,
        PROFILE: 4,
        PAYMENT: 5,
        THANK_YOU:6,
        SM_PREORDER: 8,
        ADDITIONAL_SERVICES: 9,
        IRROPS: 10,
        CHECKIN: 11,
        DEFAULT: 99
    },
    WORKER_COMMANDS = {
        START_EXTEND_SESSION_COUNTDOWN: "startExtendSessionCountdownInterval",
        START_HANDLE_COUNTDOWN_ACTION: "startHandleCountdownActionsInterval",
        START_UPDATE_REMAINING_TIME: "startUpdateRemainingTimeInterval",
        START_EXTEND_SESSION_REQUEST: "startExtendSessionInterval",
        STOP_EXTEND_SESSION_COUNTDOWN: "stopExtendSessionCountdownInterval",
        STOP_HANDLE_COUNTDOWN_ACTION: "stopHandleCountdownActionsInterval",
        STOP_UPDATE_REMAINING_TIME: "stopUpdateRemainingTimeInterval",
        CALL_EXTEND_SESSION_COUNTDOWN: "callExtendSessionCountdown",
        CALL_HANDLE_COUNTDOWN_ACTIONS: "callHandleCountdownActions",
        CALL_UPDATE_REMAINING_TIME: "callUpdateRemainingTime",
        CALL_EXTEND_SESSION_REQUEST: "callExtendSessionRequest"
    },
    SESSION_TIMEOUT_DEFAULT = 600,
    WARNING_TIMEOUT_DEFAULT = 240,
    DIFFERENCE_TIMEOUT_DEFAULT =  SESSION_TIMEOUT_DEFAULT - WARNING_TIMEOUT_DEFAULT,
    SESSION_TIMEOUT_RESUME_TOKEN = 700,
    WARNING_TIMEOUT_RESUME_TOKEN = 243,
    DIFFERENCE_TIMEOUT_RESUME_TOKEN  =  SESSION_TIMEOUT_RESUME_TOKEN - WARNING_TIMEOUT_RESUME_TOKEN,
    BASE_PATH = window.location.host === 'localhost'? toCDNPATH('assets/js') : toCDNPATH('/com.thy.web.online.portal/assets/js');

    var sessionControls = {
        intervalWorker: new Worker(BASE_PATH + "/eteration/widgets/ui-session-controls-worker.js"),
        sessionKey: "sessionKey",

        // Variables for payment operation type checks
        paymentOperationTypes: ["TICKETING", "RESERVATION_SALE", "AWARD_TICKET", "GIFT_CARD_SALE"],
        paymentOperationType: "paymentOperationType",

        // Current page
        activePageNumber: 0,

        // Time value when page is loaded.
        loadTime: Math.floor(new Date().getTime() / 1000),

        // Temporary date variable for calculations
        dateToCalculate: undefined,

        // Time required for session to end
        sessionTimeout: SESSION_TIMEOUT_DEFAULT,
        // Time value difference between session timeout and warning timeout
        differenceTimeout: DIFFERENCE_TIMEOUT_DEFAULT,
        // Time required for warning modal timeout
        warningTimeout: WARNING_TIMEOUT_DEFAULT,

        // Extend session time calculation variables
        extendSessionTokenStartTime: 0,
        extendSessionSeverTime: 0,
        extendSessionDurationLimit: 0,

        // MyTrips page state
        isMyTrips: false,

        // Countdown flag, if true countdown continue
        timeExtends: true,

        // Search again function
        availabilityFunction: null,

        // Modal state variables
        warningSessionModalShowed: false,
        endSessionModalShowed: false,
        extendSessionWarningModalShowed: false,
        extendSessionEndModalShowed: false,
        rhsSessionModalParameter: true, //when feature toggle ready, it will update
        resumeTokenCount: 0,
        rhsModalShown: sessionStorage.getItem('rhsModalShown') || false,


        // --- AJAX FUNCTIONS --- //

        handleTimeoutEnds: function () {
            etrAjax.post({
                app: "app.ibs",
                service: '/frontEnd/endConversationSafely/' + self.activePageNumber + '/' + self.sessionKey + '/' + new Date().getTime(),
                disableLoader: true,
                global: false,
                callback: function (response) {},
            });

            if (self.activePageNumber !== PAGE.THANK_YOU) {
                self.redirect();
            }
            gtmUtil.pushTimeoutPopUpEvent(null, "timedout_popup_selected", self.activePageNumber, "Return to the homepage");
        },

        extendSessionRequest: function () {
            etrAjax.post({
                app: "app.ibs",
                service: '/frontEnd/extendSession/' + new Date().getTime(),
                disableLoader: true,
                global: false,
                callback: function () {},
            });
        },

        clearTerminalRequest: function () {
            etrAjax.post({
                app: "app.ibs",
                service: '/frontEnd/clearTerminal/' + self.activePageNumber + '/' + self.sessionKey + '/' + new Date().getTime(),
                disableLoader: true,
                global: false,
                async: false,
                callback: function () {},
            });
        },

        requestExtendSession: function () {
            etrAjax.post({
                app: "app.ibs",
                service: "/checkinYUS/getseatpurchasetokendatetime",
                callback: function (response) {
                    if (response && response.data) {
                        // Extract relevant data from the response
                        var expireIntervalInMillis = response.data.expireIntervalInMillis;
                        var nowDateTimeInMillis = response.data.nowDateTimeInMillis;
                        var startDateTimeInMillis = response.data.startDateTimeInMillis;


                        // Check if the session is still valid
                        if (nowDateTimeInMillis - startDateTimeInMillis < expireIntervalInMillis) {
                            // Start the countdown interval
                            self.extendSessionDurationLimit = expireIntervalInMillis;
                            self.extendSessionSeverTime = nowDateTimeInMillis;
                            self.extendSessionTokenStartTime = startDateTimeInMillis;
                            self.intervalWorker.postMessage({command: WORKER_COMMANDS.START_EXTEND_SESSION_COUNTDOWN});
                        } else {
                            // Session is expired, rollback seat purchase
                            etrAjax.post({
                                app: "app.ibs",
                                service: "/checkinYUS/rollbackseatpurchase/SEATMAP",
                                callback: function (rollbackResponse) {
                                    // Check if the rollback response and its data are not null

                                    if (rollbackResponse && rollbackResponse.data) {
                                        // Clear the countdown interval, close modal, and reload the page
                                        self.intervalWorker.postMessage({command: WORKER_COMMANDS.STOP_EXTEND_SESSION_COUNTDOWN});
                                        self.modalIsOpen = false;
                                        location.reload();
                                    }
                                },
                            });
                        }
                    }
                },
            });
        },

        requestExtendSeatPurchase: function () {
            etrAjax.post({
                app: "app.ibs",
                service: "/checkinYUS/extendseatpurchase",
                callback: function (response) {
                    if (response && response.data) {
                        self.intervalWorker.postMessage({command: WORKER_COMMANDS.STOP_EXTEND_SESSION_COUNTDOWN});
                        self.requestExtendSession();
                        $("#extendSessionWarningModal").modal("hide");
                        self.modalIsOpen = false;
                    }
                },
            });
        },

        getSessionDataRequest: function () {
            // Function to keep up the session start, continue or end on initial page load
            var setupProcess = function (pagesTimeout) {
                if (pagesTimeout !== null) {
                    self.sessionTimeout = pagesTimeout;
                    self.warningTimeout = pagesTimeout <= WARNING_TIMEOUT_DEFAULT ? pagesTimeout : WARNING_TIMEOUT_DEFAULT;
                    self.differenceTimeout = pagesTimeout - self.warningTimeout;

                    if (self.differenceTimeout < 0) {
                        self.differenceTimeout = 20;

                        if (self.sessionTimeout < 20) {
                            self.differenceTimeout = 5;
                        }
                    }
                } else {
                    self.sessionTimeout = SESSION_TIMEOUT_DEFAULT;
                    self.warningTimeout = WARNING_TIMEOUT_DEFAULT;
                    self.differenceTimeout = self.sessionTimeout - self.warningTimeout;
                }

                // Start the countdown process
                self.start();
            };

            etrAjax.post({
                app: "app.ibs",
                service: '/frontEnd/fecParams/' + self.activePageNumber + '/' + self.sessionKey + '/' + new Date().getTime(),
                disableLoader: true,
                global: false,
                callback: function (response) {
                    if (response && response.data) {
                        self.isMyTrips = response.data.IS_MY_TRIPS;
                        setupProcess(response.data.PAGES_TIMEOUT);
                    }
                },
            });
        },

        getResumeSessionDataRequest: function () {
            // Service request control for whether the session period can be restarted
            etrAjax.post({
                app: "app.ibs",
                service: '/frontEnd/resumeToken/' + self.activePageNumber + '/' + self.sessionKey + '/' + new Date().getTime(),
                disableLoader: true,
                global: false,
                callback: function (response) {
                    self.resumeTokenCount = response.data && response.data.resumeTokenCount;
                    // Check if session needs to end
                    if (response && response.data && (response.data.endSession || response.data.endSession === "true")) {
                        self.showSessionEndModal();
                        return;
                    }

                    // Check if session can be continue
                    if (response && response.data && (response.data.reInit || response.data.reInit === "true")) {
                        self.reInit();
                    }
                },
            });
        },

        // --- PRIVATE FUNCTIONS  --- //

        setPaymentOperationType: function (operationTypeParam) {
            self.paymentOperationType = operationTypeParam;
        },

        isIE9OrUnder: function () {
            // Check for localhost or 127.0.0.1
            if (window.location.host.includes("localhost") || window.location.host.includes("127.0.0.1")) {
                return false;
            }

            // Check for Internet Explorer
            var userAgent = window.navigator.userAgent;
            var userAgentIndex = userAgent.indexOf("MSIE ");
            var isIE = userAgentIndex || !!userAgent.match(/Trident.*rv\:11\./);
            var minIeVersion = 10;

            if (isIE) {
                // Extract IE version number
                var ieVersion = parseInt(userAgent.substring(isIE + 5, userAgent.indexOf(".", userAgentIndex)));

                // Check if version is below the minimum
                return !isNaN(ieVersion) && minIeVersion > ieVersion;
            }

            // Not Internet Explorer
            return false;
        },

        disallowBack: function () {
            var isIE90rUnder = self.isIE9OrUnder();

            // Check if the browser is not an old version of Internet Explorer
            if (!isIE90rUnder) {
                // Disallow the back button by manipulating the browser history
                history.pushState(null, null, location.href);

                // Override the popstate event to prevent navigating back
                window.onpopstate = function () {
                    history.go(1);
                };
            }
        },

        disallowForward: function () {
            history.pushState("", window.document.title, document.URL);
        },

        isPaymentTicketing: function () {

            if (self.activePageNumber === PAGE.PAYMENT) {
                // Check if the payment operation type corresponds to ticketing
                return self.paymentOperationTypes.includes(self.paymentOperationType);
            }
            return false;
        },

        handleBrowserForwardBackwardActions: function () {
            // Disable forward actions on browser
            self.disallowForward();

            // Disable back button on browser for pages
            if (self.activePageNumber === PAGE.SCHEDULE || self.activePageNumber === PAGE.THANK_YOU) {
                self.disallowBack();
            }
        },

        getStartPageUrl: function () {
            // Try to get the URL from sessionStorage
            var queryParamsIndex;
            var redirectPage = storageHelper.getItem({
                key: "startSchedulePageUrl",
                webStorageType: storageHelper.Stores.SESSION_STORAGE
            });;

            // If not found in sessionStorage, try to get it from cookies
            if (!redirectPage) {
                try {
                    var cookieName = "startSchedulePageUrl=";
                    var cookieArray = document.cookie.split(";");

                    for (var i = 0; i < cookieArray.length; i++) {
                        var cookie = cookieArray[i].trim();

                        if (cookie.indexOf(cookieName) === 0) {
                            redirectPage = cookie.substring(cookieName.length);

                            // Remove query parameters if present
                            queryParamsIndex = redirectPage.indexOf("?");

                            if (queryParamsIndex > -1) {
                                redirectPage = redirectPage.substring(0, queryParamsIndex);
                            }
                        }
                    }
                } catch (e) {
                    // Handle potential errors while parsing cookies
                }
            }

            // If still not found, fallback to global variable or current hostname
            if (!redirectPage) {
                redirectPage = window.startUrl || window.location.protocol + "//" + window.location.hostname;
            }

            // Remove query parameters if present
            queryParamsIndex = redirectPage.indexOf("?");

            if (queryParamsIndex > -1) {
                redirectPage = redirectPage.substring(0, queryParamsIndex);
            }

            return redirectPage;
        },

        setTimeoutConversation: function () {
            var cid = urlParser.getUrlVar("cId");

            if (cid) {
                var jStorageConfig = { TTL: 3600000 };
                var key = 'app/terminatedConversationBofTimeout/' + cid;
                $.jStorage.set(key, cid, jStorageConfig);
            }

        },

        checkTimeoutConversation: function () {
            // Get the conversation ID from the URL
            var cid = urlParser.getUrlVar("cId");

            if (cid) {
                // Check if there's a stored value for the conversation timeout
                var result = $.jStorage.get('app/terminatedConversationBofTimeout/' + cid);

                // If the result is not null, the conversation timeout is set
                return result !== null;
            }

            return false;
        },

        generateTwoDigitsTime: function (timeValue, digitLength) {
            return (new Array(digitLength + 1).join("0") + timeValue).slice(-digitLength);
        },

        clearAllIntervals: function () {
            self.intervalWorker.postMessage({command: WORKER_COMMANDS.STOP_UPDATE_REMAINING_TIME});
            self.intervalWorker.postMessage({command: WORKER_COMMANDS.STOP_HANDLE_COUNTDOWN_ACTION});
        },

        resetModalStates: function () {

            self.warningSessionModalShowed = false;
            self.endSessionModalShowed = false;
        },

        // --- MODAL MANAGEMENT --- //

        hideModals: function () {
            if($("#walletMigrationPopup").is(':visible')) {
                window.resetToggleCollapse && window.resetToggleCollapse();
            }
            $(".modal").modal('hide');
        },

        showModalWithDelay: function (modalId) {
            // Fix for sometimes backdrop stays hidden, it occurs because async modal process
            setTimeout(function () {$(modalId).modal("show")}, 500)
        },
        showRHSModal: function () {
            self.hideModals();

            if($("#sessionRHSModal").length === 0) {
                window.showRHSModal();
                sessionStorage.setItem('rhsModalShown',true);
            }

            self.warningTimeout = self.warningTimeout - (self.dateToCalculate - (self.differenceTimeout + self.loadTime));

            // Check if necessary objects are available
            if (self.warningTimeout && self.activePageNumber !== "") {
                self.setRemainingTimeDisplay();
            }

            // Reset counter interval
            self.intervalWorker.postMessage({command: WORKER_COMMANDS.STOP_UPDATE_REMAINING_TIME});

            self.endSessionModalShowed = false;
            self.intervalWorker.postMessage({command: WORKER_COMMANDS.START_UPDATE_REMAINING_TIME});
        },

        handleSessionContinue:function () {
            self.clearAllIntervals();

            // If the user confirms, extend the session and take appropriate actions
            self.timeExtends = true;
            self.loadTime = self.dateToCalculate;
            self.intervalWorker.postMessage({command: WORKER_COMMANDS.START_HANDLE_COUNTDOWN_ACTION});
            // Check conditions for different actions based on activePageNumber and other factors
            if (
                [
                    PAGE.AVAILABILITY,
                    PAGE.SUMMARY,
                    PAGE.PROFILE,
                    PAGE.SM_PREORDER,
                    PAGE.ADDITIONAL_SERVICES,
                    PAGE.IRROPS,
                ].includes(self.activePageNumber) ||
                self.isPaymentTicketing()
            ) {
                self.resumeToken();
            } else {
                self.reInit();
            }

            self.resetModalStates();
        },

        showSessionWarningModal: function () {
            self.hideModals();

            if($("#sessionWarningModal").length === 0) {

                var handleWarningButtonCancel = function () {
                    gtmUtil.pushTimeoutPopUpEvent(null, "timeout_popup_selected", self.activePageNumber, "No", self.warningTimeout);
                    self.clearAllIntervals();

                    // If the user cancels, reset flags and redirect
                    self.timeExtends = false;

                    // Check conditions for resetting the interval and clearing terminal based on activePageNumber and other factors
                    if (self.isMyTrips === false) {
                        self.intervalWorker.postMessage({command: WORKER_COMMANDS.START_HANDLE_COUNTDOWN_ACTION});

                        if (self.activePageNumber === PAGE.PROFILE || self.isPaymentTicketing()) {
                            self.clearTerminalRequest();
                        }
                    }

                    self.redirect();
                    self.resetModalStates();
                };

                $("body").append(
                    '<div id="sessionWarningModal" class="modal fade" tabindex="-1" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false">' +
                    '   <div class="modal-dialog" role="document">' +
                    '      <div class="modal-content">' +
                    '         <div class="modal-body">' +
                    '            <div class="col-12 text-center mt-25 mt-15-mbl" id="timer">' +
                    '               <span id="remainingTimeSpan"></span>' +
                    '            </div>' +
                    '            <div class="col-12 text-center mt-25">' +
                    '               <span class="fs-16 fw700">' + i18n.get("sessionwarningmodal.header") + '</span>' +
                    '            </div>' +
                    '            <div class="col-12 text-center mt-25 mt-20-mbl ms-60 me-30 mb-5 mb-0-mbl">' +
                    '               <span class="fs-13 fw700 shade-of-cyan-blue">' + i18n.get("sessionwarningmodal.description") + '</span>' +
                    '            </div>' +
                    '         </div>' +
                    '         <div class="modal-footer">' +
                    '            <button type="button" class="btn btn-danger btn-lg bold btn-session-modal fs-16 m-0-mbl pull-right-sm" data-bs-dismiss="modal" id="sessionWarningModalConfirm">' + i18n.get("Label-Genel-521") + '</button>' +
                    '            <button type="button" class="btn btn-link btn-lg bold blue text-decoration-none fs-16 me-20 w-100-mbl m-0-mbl" data-bs-dismiss="modal" id="sessionWarningModalCancel">' + i18n.get("Label-Genel-522") + '</button>' +
                    '         </div>' +
                    '      </div>' +
                    '   </div>' +
                    '</div>'
                );

                $("body").on("click", "#sessionWarningModalConfirm", self.handleSessionContinue);
                $("body").on("click", "#sessionWarningModalCancel", handleWarningButtonCancel);
            }

            $("#sessionWarningModal").modal("show");
            self.warningTimeout = self.warningTimeout - (self.dateToCalculate - (self.differenceTimeout + self.loadTime));

            // Check if necessary objects are available
            if (self.warningTimeout && self.activePageNumber !== "") {
                self.setRemainingTimeDisplay();
            }

            // Reset counter interval
            self.intervalWorker.postMessage({command: WORKER_COMMANDS.STOP_UPDATE_REMAINING_TIME});

            self.endSessionModalShowed = false;
            self.intervalWorker.postMessage({command: WORKER_COMMANDS.START_UPDATE_REMAINING_TIME});
        },

        showSessionEndModal: function () {
            self.intervalWorker.postMessage({command: WORKER_COMMANDS.STOP_HANDLE_COUNTDOWN_ACTION});
            self.hideModals();

            // Handle session end
            self.setTimeoutConversation();
            self.extendSessionRequest();

            if($("#sessionEndModal").length === 0) {
                var showSearchAgainButton = self.availabilityFunction;

                var descriptionKey = showSearchAgainButton
                    ? i18n.get("sessionendmodal.description.availability")
                    : i18n.get("sessionendmodal.description");

                if (showSearchAgainButton) {
                    self.handleSearchAgain = function () {
                        etrAjax.post({
                            app: "app.ibs",
                            service: '/frontEnd/endConversationSafely/' + self.activePageNumber + '/' + self.sessionKey + '/' + new Date().getTime(),
                            disableLoader: true,
                            global: false,
                            callback: function () {
                                self.availabilityFunction();
                            }
                        });
                        gtmUtil.pushTimeoutPopUpEvent(null, "timedout_popup_selected", self.activePageNumber, "Search again");
                    };
                }


                var sessionEndModalHTML = '<div id="sessionEndModal" class="modal fade" tabindex="-1" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false">' +
                    '<div class="modal-dialog" role="document">' +
                    '<div class="modal-content">' +
                    '<div class="modal-body">' +
                    '<div class="col-xs-12 text-center mt-35">' +
                    '<span class="fs-16 fw700">' + i18n.get("sessionendmodal.header") + '</span>' +
                    '</div>' +
                    '<div class="col-xs-12 text-center mt-25 mt-15-mbl ms-60 me-30-sm ms-0-mbl p-0-mbl">' +
                    '<span class="fs-13 fw700 shade-of-cyan-blue">' + descriptionKey + '</span>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    (showSearchAgainButton ? '<button type="button" class="btn btn-danger btn-lg bold btn-session-modal fs-16 m-0-mbl pull-right-sm mt-15-mbl" data-bs-dismiss="modal" id="sessionEndModalSearchAgain">' + i18n.get("sessionendmodal.searchagain") + '</button>' : '') +
                    '<button type="button" class="btn btn-link btn-lg bold blue text-decoration-none fs-16 me-20 w-100-mbl m-0-mbl" data-bs-dismiss="modal" id="sessionEndModalRedirect">' + i18n.get("sessionendmodal.redirect") + '</button>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '</div>';

                $("body").append(sessionEndModalHTML);

                $("body").on("click", "#sessionEndModalSearchAgain", self.handleSearchAgain);
                $("body").on("click", "#sessionEndModalRedirect", self.handleTimeoutEnds);
            }

            self.showModalWithDelay("#sessionEndModal");
        },

        showExtendSessionWarningModal: function () {
            self.hideModals();
            self.extendSessionWarningModalShowed = true;


            if($("#extendSessionWarningModal").length === 0) {
                var extendSessionWarningModalHTML = '<div class="modal fade" id="extendSessionWarningModal" tabindex="-1" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false">' +
                    '<div class="modal-dialog" role="document">' +
                    '<div class="modal-content">' +
                    '<div class="modal-header">' +
                    '<h5 class="modal-title">' + i18n.get("TextField-OCI-341") + '</h5>' +
                    '</div>' +
                    '<div class="modal-body">' +
                    i18n.get("TextField-OCI-341") + ' <span id="remainingTimeSpan"></span>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button type="button" class="btn btn-primary" id="extendSessionWarningModalExtend">' + i18n.get("Label-Genel-521") + '</button>' +
                    '<button type="button" class="btn btn-default" id="extendSessionWarningModalRedirect" data-bs-dismiss="modal">' + i18n.get("Label-Genel-522") + '</button>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '</div>';

                $("body").append(extendSessionWarningModalHTML);

                $("body").on("click", "#extendSessionWarningModalExtend", self.requestExtendSeatPurchase);
                $("body").on("click", "#extendSessionWarningModalRedirect", self.redirect);
            }

            $("#extendSessionWarningModal").modal("show");
        },

        showExtendSessionEndModal: function () {
            self.hideModals();
            self.extendSessionEndModalShowed = true;

            if($("#extendSessionEndModal").length === 0) {
                var extendSessionEndModalHTML = '<div class="modal fade" id="extendSessionEndModal" tabindex="-1" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false">' +
                    '<div class="modal-dialog" role="document">' +
                    '<div class="modal-content">' +
                    '<div class="modal-header">' +
                    '<h5 class="modal-title"></h5>' +
                    '</div>' +
                    '<div class="modal-body">' +
                    i18n.get("TextField-OCI-355") +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button type="button" class="btn btn-primary" id="extendSessionEndModalRedirect">OK</button>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '</div>';

                $("body").append(extendSessionEndModalHTML);
                $("body").on("click", "#extendSessionEndModalRedirect", self.redirect);
            }

            $("#extendSessionEndModal").modal("show");
        },

        // --- SESSION TIMEOUT MANAGEMENT --- ///

        extendSessionCountdown: function () {
            self.extendSessionSeverTime += 1000;
            var durationTime = self.extendSessionSeverTime - self.extendSessionTokenStartTime;
            var countDownValue = self.extendSessionDurationLimit - durationTime;

            if (countDownValue <= 0) {
                // Handle Count Down Expired
                self.intervalWorker.postMessage({command: WORKER_COMMANDS.STOP_EXTEND_SESSION_COUNTDOWN});
            } else if (countDownValue <= 1000) {
                // Handle Count Down End
                if (!self.extendSessionEndModalShowed) self.showExtendSessionEndModal();
            } else if (countDownValue <= 59000) {
                // Handle Count Down Warning
                if (!self.extendSessionWarningModalShowed) {
                    self.showExtendSessionWarningModal();
                }
            }

            var remainingTimeSpan = document.getElementById("remainingTimeSpan");

            if (remainingTimeSpan !== null && countDownValue >= 0) {
                remainingTimeSpan.innerHTML = Math.floor(countDownValue / 1000).toString();
            }
        },

        setRemainingTimeDisplay: function () {
            var remainingTimeSpanElement = $("#remainingTimeSpan");

            // Update the remaining time display
            if (remainingTimeSpanElement.length > 0) {
                var time = self.warningTimeout;
                var minutes = Math.floor(time / 60);
                var seconds = time - minutes * 60;

                var finalTime = self.generateTwoDigitsTime(minutes, 2) + ":" + self.generateTwoDigitsTime(seconds, 2);

                remainingTimeSpanElement.html(finalTime);
            }
        },

        updateRemainingTime: function () {
            if (self.warningTimeout) {
                self.warningTimeout--;

                // Reset counter if it goes below 0
                if (self.warningTimeout < 0) {
                    self.warningTimeout = 0;
                    self.intervalWorker.postMessage({command: WORKER_COMMANDS.STOP_UPDATE_REMAINING_TIME});
                }

                self.setRemainingTimeDisplay();
            }
        },

        handleCountdownActions: function () {
            self.dateToCalculate = Math.floor(new Date().getTime() / 1000);

            // Check if the activePageNumber conditions
            if (self.activePageNumber !== PAGE.SCHEDULE && self.activePageNumber !== PAGE.THANK_YOU && self.activePageNumber !== "") {
                if (self.timeExtends) {
                    // Handle show session end modal
                    if (self.loadTime + self.sessionTimeout < self.dateToCalculate && !self.endSessionModalShowed) {
                        self.endSessionModalShowed = true;
                        self.showSessionEndModal();
                        gtmUtil.pushTimeoutPopUpEvent(null, "timedout_popup_view", self.activePageNumber);
                    }
                    // Handle show warning
                    else if (self.loadTime + self.differenceTimeout < self.dateToCalculate && !self.warningSessionModalShowed) {
                        self.warningSessionModalShowed = true;
                        self.hasBaseOffer = sessionStorage.getItem('hasBaseOffer') == "true";
                        if(self.rhsSessionModalParameter && self.resumeTokenCount == 2 && !self.rhsModalShown && self.hasBaseOffer){
                            self.showRHSModal();
                        }else{
                            self.showSessionWarningModal();
                        }
                        gtmUtil.pushTimeoutPopUpEvent("timeout_popup_view", self.activePageNumber);
                    }
                    // Handle after endSesssionModalShowed
                    else if (self.endSessionModalShowed) {
                        self.clearAllIntervals();
                    }
                }
            }
            // Clear interval if the activePageNumber is 1 or 6
            else {
                self.intervalWorker.postMessage({command: WORKER_COMMANDS.STOP_HANDLE_COUNTDOWN_ACTION});
            }
        },

        // --- MAIN FUNCTIONS --- ///

        setAvailabilityFunction: function (availabilityFunction) {
            self.availabilityFunction = availabilityFunction;
        },

        updateStartSchedulePageUrl: function () {
            // Store the current page URL in sessionStorage
            storageHelper.setItem({
                key: "startSchedulePageUrl",
                value: document.URL,
                webStorageType: storageHelper.Stores.SESSION_STORAGE
            });

            // Check if the URL matches the domain
            if (document.URL && document.URL.match(/^https:\/\/.*\.turkishairlines.com/)) {
                // Set a cookie with the current page URL
                document.cookie = "startSchedulePageUrl=" + document.URL + "; path=/";
            }

            // Set the current page URL to a global variable
            window.startUrl = document.URL;
        },

        redirect: function () {
            var startPageUrl = self.getStartPageUrl();

            // Check if the user is logged in and on the 'miles-and-smiles' page
            if (window.loggedIn() && document.URL.includes("miles-and-smiles")) {
                document.getElementById("signoutBTN").click();
            }

            // Check if the current URL is different from the start page URL, then redirect
            if (document.URL !== startPageUrl) {
                window.location.replace(startPageUrl);
            }
        },

        setActivePageNumber: function (activePageNumber) {
            self.activePageNumber = activePageNumber;

            // if homepage condition
            if (activePageNumber === PAGE.SCHEDULE) {
                self.updateStartSchedulePageUrl();
            }

            if (activePageNumber !== "") {
                self.init();
            }

            self.handleBrowserForwardBackwardActions();
        },

        init: function () {
            // Set a timeout to execute the setup process
            setTimeout(function () {
                // Get or generate a unique session key
                var sessionKey = sessionData.getItem("tabSessionId");

                if (!sessionKey) {
                    // Generates a sessionkey "random(1-10000)-random(1-10000))
                    sessionKey = Math.floor(Math.random() * 10000 + 1) + "-" + Math.floor(Math.random() * 10000 + 1);

                    sessionData.setItem("tabSessionId", sessionKey);
                    self.sessionKey = sessionKey;
                }

                if (self.checkTimeoutConversation()) {
                    self.showSessionEndModal();
                    return;
                }

                self.getSessionDataRequest()
            }, 100);

            // Set a interval to extend session
            self.intervalWorker.postMessage({command: WORKER_COMMANDS.START_EXTEND_SESSION_REQUEST});
        },

        reInit: function () {
            console.info("Session Control ReInitiated");
            self.init();
        },

        start: function () {
            window.timeout = false;

            // Conditions to start session countdown intervals
            if (self.isMyTrips === false || self.activePageNumber === PAGE.DEFAULT){
                self.intervalWorker.postMessage({command: WORKER_COMMANDS.STOP_HANDLE_COUNTDOWN_ACTION});
                self.intervalWorker.postMessage({command: WORKER_COMMANDS.START_HANDLE_COUNTDOWN_ACTION});
            }
        },

        resumeToken: function () {
            // Set initial values
            self.sessionTimeout = SESSION_TIMEOUT_RESUME_TOKEN;
            self.differenceTimeout = DIFFERENCE_TIMEOUT_RESUME_TOKEN;
            self.warningTimeout = WARNING_TIMEOUT_RESUME_TOKEN;

            // Check conditions to get resume session information request
            if (self.isMyTrips === false || self.activePageNumber == PAGE.DEFAULT) {
                self.getResumeSessionDataRequest()
            } else {
                self.reInit();
            }
        },

        initExtendSessionForCheckin: function () {
            self.requestExtendSession();
        },
    };

    var self = sessionControls;

    self.intervalWorker.onmessage = function (event) {
        var message = event.data;

        if(message && message.command){
            var command = message.command

            switch(command) {
                case WORKER_COMMANDS.CALL_EXTEND_SESSION_COUNTDOWN:
                   return self.extendSessionCountdown();

                case WORKER_COMMANDS.CALL_HANDLE_COUNTDOWN_ACTIONS:
                    return self.handleCountdownActions();

                case WORKER_COMMANDS.CALL_UPDATE_REMAINING_TIME:
                    return self.updateRemainingTime();

                case WORKER_COMMANDS.CALL_EXTEND_SESSION_REQUEST:
                    return self.extendSessionRequest();

                default:
                    break;
            }
        }
    };

    self.intervalWorker.postMessage({command:"loadCommands", data: WORKER_COMMANDS})

    return sessionControls
});
